import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { KeyRound, Lock, ArrowLeft, ShieldAlert } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminRecoveryPage = () => {
  const [recoveryKey, setRecoveryKey] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!recoveryKey) {
      toast.error('Recovery Key टाका');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      toast.error('Passwords जुळत नाहीत');
      return;
    }
    
    if (newPassword.length < 6) {
      toast.error('Password किमान 6 characters असावा');
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/auth/admin-recovery`, {
        recovery_key: recoveryKey,
        new_password: newPassword
      });
      
      if (response.data.success) {
        toast.success(`Admin password reset झाला! Username: ${response.data.admin_username}`);
        navigate('/login');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Recovery failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-4">
      <Card className="w-full max-w-md shadow-2xl border-0 bg-slate-800">
        <CardHeader className="space-y-2 pb-6">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center">
              <ShieldAlert className="h-8 w-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-center font-heading text-white">
            Admin Recovery
          </CardTitle>
          <CardDescription className="text-center text-slate-400">
            Emergency Admin Password Reset
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="recoveryKey" className="text-slate-300 font-medium">
                Recovery Key
              </Label>
              <div className="relative">
                <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
                <Input
                  id="recoveryKey"
                  type="password"
                  placeholder="Enter recovery key"
                  value={recoveryKey}
                  onChange={(e) => setRecoveryKey(e.target.value)}
                  className="pl-10 h-12 bg-slate-700 border-slate-600 text-white placeholder:text-slate-500"
                  required
                />
              </div>
              <p className="text-xs text-slate-500">
                हे secret key फक्त तुम्हाला माहित असेल
              </p>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="newPassword" className="text-slate-300 font-medium">
                New Password
              </Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
                <Input
                  id="newPassword"
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="pl-10 h-12 bg-slate-700 border-slate-600 text-white placeholder:text-slate-500"
                  required
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="confirmPassword" className="text-slate-300 font-medium">
                Confirm Password
              </Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
                <Input
                  id="confirmPassword"
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="pl-10 h-12 bg-slate-700 border-slate-600 text-white placeholder:text-slate-500"
                  required
                />
              </div>
            </div>

            <Button
              type="submit"
              className="w-full h-12 bg-red-600 text-white hover:bg-red-700 font-semibold"
              disabled={isLoading}
            >
              {isLoading ? 'Resetting...' : 'Reset Admin Password'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <a 
              href="/login" 
              className="text-sm text-slate-400 hover:text-white flex items-center justify-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to Login
            </a>
          </div>
          
          <div className="mt-4 p-3 bg-yellow-900/30 rounded-lg border border-yellow-700/50">
            <p className="text-xs text-yellow-500 text-center">
              ⚠️ हे page फक्त emergency साठी आहे. Recovery Key सुरक्षित ठेवा.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminRecoveryPage;
